import React, { PureComponent } from 'react';

const BURST_COUNT = 6;
const SPARK_COUNT = 14;

class FireworksAnimation extends PureComponent {
    constructor(props) {
        super(props);
        const hues = [0, 30, 55, 180, 270, 320];
        this.bursts = Array.from({ length: BURST_COUNT }, (_, i) => ({
            id: i,
            x: 15 + Math.random() * 70,
            y: 15 + Math.random() * 50,
            delay: i * 0.35 + Math.random() * 0.2,
            hue: hues[i % hues.length],
            sparks: Array.from({ length: SPARK_COUNT }, (_, j) => {
                const angle = (j / SPARK_COUNT) * 360;
                const distance = 60 + Math.random() * 50;
                return {
                    id: j,
                    x: Math.cos((angle * Math.PI) / 180) * distance,
                    y: Math.sin((angle * Math.PI) / 180) * distance,
                    size: 3 + Math.random() * 4,
                    duration: 0.8 + Math.random() * 0.6,
                };
            }),
        }));
    }

    render() {
        return (
            <div style={styles.container}>
                <style>{keyframes}</style>
                {this.bursts.map(burst => (
                    <div
                        key={burst.id}
                        style={{
                            position: 'absolute',
                            left: `${burst.x}%`,
                            top: `${burst.y}%`,
                        }}
                    >
                        <div
                            style={{
                                ...styles.flash,
                                animationDelay: `${burst.delay}s`,
                                background: `radial-gradient(circle, hsla(${burst.hue}, 100%, 85%, 0.9), transparent 70%)`,
                            }}
                        />
                        {burst.sparks.map(spark => (
                            <div
                                key={spark.id}
                                style={{
                                    ...styles.spark,
                                    width: spark.size,
                                    height: spark.size,
                                    backgroundColor: `hsl(${burst.hue}, 100%, ${65 + Math.random() * 20}%)`,
                                    boxShadow: `0 0 6px hsl(${burst.hue}, 100%, 70%)`,
                                    '--tx': `${spark.x}px`,
                                    '--ty': `${spark.y}px`,
                                    animationDelay: `${burst.delay}s`,
                                    animationDuration: `${spark.duration}s`,
                                }}
                            />
                        ))}
                    </div>
                ))}
            </div>
        );
    }
}

const keyframes = `
@keyframes fw-spark {
    0% { transform: translate(0, 0) scale(1); opacity: 1; }
    80% { opacity: 0.8; }
    100% { transform: translate(var(--tx), var(--ty)) scale(0); opacity: 0; }
}
@keyframes fw-flash {
    0% { transform: scale(0); opacity: 0; }
    15% { transform: scale(1); opacity: 1; }
    100% { transform: scale(2); opacity: 0; }
}
`;

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        overflow: 'hidden',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    spark: {
        position: 'absolute',
        borderRadius: '50%',
        animation: 'fw-spark ease-out forwards',
        opacity: 0,
    },
    flash: {
        position: 'absolute',
        width: 80,
        height: 80,
        marginLeft: -40,
        marginTop: -40,
        borderRadius: '50%',
        animation: 'fw-flash 0.6s ease-out forwards',
        opacity: 0,
    },
};

export default FireworksAnimation;
